<template>
  <Modal
    v-model="_value"
    width="500"
    title='博实结触发报警行为'
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onSendDriverCardParams">

    <Form :label-width="110">
      <FormItem prop="alarm" label="触发报警行为">
        <Select v-model="alarm" style="width: 220px;">
          <Option v-for="item in alarmOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
    </Form>
    <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
    <Button type="primary" @click="onSendDriverCardParams">发送</Button>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'bsjsettriggeralarmmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      businessUserId: null,
    },
    data() {
      return {
        //报警行为选项
        alarm:null,

        // 2           1     前车碰撞
        //   2           2     车道偏离
        // 2           3     车距过近
        //   2           4     行人碰撞
        // 2           18    实线变道
        //   2           19    过道行人检查
        // 2           251   后方接近报警
        //   2           52    左侧后方接近报警
        // 2           53    右侧后方接近报警
        //   2           54    前车盲区报警
        // 2           101   闭眼
        //   2           102   打电话
        // 2           103   抽烟
        //   2           104   分神
        // 2           105   驾驶员异常
        //   2           106   打哈欠
        // 2           107   红外阻断
        //   2           108   dms遮挡
        // 2           109   驾驶员变更
        //   2           110   安全带
        // 2           111   玩手机
        //   2           112   双手脱离方向盘
        // 2           113   超时驾驶
        alarmOptions: [
          // {name: '前车碰撞', value: 1},
          // {name: '车道偏离', value: 2},
          // {name: '车距过近', value: 3},
          // {name: '行人碰撞', value: 4},
          // {name: '实线变道', value: 18},
          // {name: '过道行人检查', value: 19},
          // {name: '后方接近报警', value: 251},
          // {name: '左侧后方接近报警', value: 52},
          // {name: '右侧后方接近报警', value: 53},
          // {name: '前车盲区报警', value: 54},
          {name: '闭眼', value: 101},
          // {name: '打电话', value: 102},
          // {name: '抽烟', value: 103},
          // {name: '分神', value: 104},
          // {name: '驾驶员异常', value: 105},
          {name: '打哈欠', value: 106},
          // {name: '红外阻断', value: 107},
          // {name: 'dms遮挡', value: 108},
          // {name: '驾驶员变更', value: 109},
          // {name: '安全带', value: 110},
          // {name: '玩手机', value: 111},
          // {name: '双手脱离方向盘', value: 112},
          // {name: '超时驾驶', value: 113},
        ],
      }
    },
    methods: {
      ...mapActions([
        'ShortMessageServ_Send'
      ]),
      onSendDriverCardParams () {
        let content = '<EXT00HEXT35/dvr/bin/bsjctl passcheck other 2 '+this.alarm+'>'

        store.dispatch('NetCommandServ_SendCommand', {
          params: { id: this._initValue, content: content , urgent: false }
        }).then(() => {
          this.$Message.success('发送成功')
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      onCleanDriverCardParams(){
        this.alarm = null
      },
      visibleChange(val) {
        if(val){
          this.alarm = null
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _businessUserId:{
        get() {
          return this.businessUserId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
          phoneNum: this.phoneNumRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
